import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import LoginSSO from './LogInSSO'
import LoginOld from './LoginOld'
import Button from '@components/Button'
import LoginCt from './LoginCt'

class Login extends Component {
  static propTypes = {
    userStore: PropTypes.object
  }
  state={ loginMethod: null}

  render () {

    if(!process.env.REACT_APP_AUTH_MODE || process.env.REACT_APP_AUTH_MODE === 'old'){
      return <LoginOld />
    }
    if(process.env.REACT_APP_AUTH_MODE === 'sso'){
      return <LoginSSO />
    }

    if(this.state.loginMethod){
      if(this.state.loginMethod === 'sso'){
        return <LoginSSO />
      }
      if(this.state.loginMethod === 'old'){
        return <LoginOld />
      }
    }

    if(process.env.REACT_APP_AUTH_MODE === 'compat'){
       return <LoginCt>
          <Button primary onClick={()=>this.setState({loginMethod:"sso"})}>
                Login SSO
          </Button>
          <Button onClick={()=>this.setState({loginMethod:"old"})}>
                Login OLD
          </Button>
       </LoginCt>
    }

    return <LoginSSO />
  }
}

export default inject('userStore')(observer(Login))
